/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Link } from "react-router";
import React from "react";
import buttonTextTermsOfServicePrivacyStyles from "./buttonTextTermsOfServicePrivacyStyles";
import Typography from "@mui/material/Typography";
import LockIcon from "@mui/icons-material/Lock";

const ButtonTextTermsOfServicePrivacy = () => {
  return (
    <Typography component="div" variant="caption" sx={buttonTextTermsOfServicePrivacyStyles.termsOfServiceText}>
      Ich stimme den{" "}
      <Link to={"/agb"} target="_blank">
        AGB der Legalbird Rechtsanwälte Rechtsanwalts GmbH
      </Link>{" "}
      und den{" "}
      <Link to={"/agb-legalbird"} target="_blank">
        AGB der Legalbird GmbH
      </Link>{" "}
      zu. Die{" "}
      <Link to={"/datenschutz"} target="_blank">
        Datenschutzerklärung der Legalbird Rechtsanwälte Rechtsanwalts GmbH
      </Link>{" "}
      und die{" "}
      <Link to={"/datenschutz-legalbird"} target="_blank">
        Datenschutzerklärung der Legalbird GmbH
      </Link>{" "}
      habe ich zur Kenntnis genommen.
      <br />
      <LockIcon sx={{ height: "12px", width: "12px", paddingTop: "2px" }} /> SSL-zertifiziert - Wir schützen Ihre Daten!
    </Typography>
  );
};

export default ButtonTextTermsOfServicePrivacy;
